import { Component } from '@angular/core';

@Component({
  selector: 'app-required-field-legend',
  standalone: true,
  template: `<span class="text-danger text-xs whitespace-nowrap"><span class="text-danger">*</span> Campo Obrigatório</span>`,
})
export class RequiredFieldLegendComponent {}
